<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="伙伴名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入伙伴名称查询" v-model="queryParam.partnerName"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="user-add" @click="openInviteModal">邀请伙伴</a-button>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="partnerRole" slot-scope="text, record">
              <a-tag v-if="partnerRoleOf(record) === '供应商'" color="green">供应商</a-tag>
              <a-tag v-else-if="partnerRoleOf(record) === '客户'" color="blue">客户</a-tag>
              <a-tag v-else color="orange">未关联</a-tag>
            </template>
            <template slot="myArchive" slot-scope="text">
              <span v-if="text">{{ text }}</span>
              <a-tag v-else color="orange">未关联</a-tag>
            </template>
            <span slot="action" slot-scope="text, record">
              <template v-if="btnEnableList.indexOf(1)>-1">
                <a v-if="!record.supplierId" @click="openLinkModal(record)">关联档案</a>
                <a-divider type="vertical" v-if="!record.supplierId" />
                <a-popconfirm title="解绑后双方将无法进行订单流转，确定解绑吗?" @confirm="() => handleUnbind(record)">
                  <a>解绑</a>
                </a-popconfirm>
              </template>
              <span v-else>-</span>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
        <!-- 邀请伙伴弹窗：选角色+必选本方未绑定档案，链接携带档案ID，对方登录即绑定+档案关联 -->
        <a-modal
          title="邀请伙伴"
          :visible="inviteVisible"
          :footer="null"
          :maskClosable="false"
          width="560px"
          @cancel="inviteVisible = false">
          <a-form>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邀请角色">
              <a-radio-group v-model="inviteRole">
                <a-radio value="supplier">邀请供应商（对方作为我的供应商）</a-radio>
                <a-radio value="customer">邀请客户（对方作为我的客户）</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联本方档案" required>
              <a-select
                v-model="inviteArchiveId"
                placeholder="请选择本方档案（仅列出未绑定的）"
                :options="inviteArchiveOptions"
                allowClear
                @change="buildInviteLinks" />
              <div class="invite-archive-tip" v-if="!inviteArchiveOptions.length">暂无可关联档案，可先在基础资料-供应商/客户管理中新增</div>
            </a-form-item>
          </a-form>
          <a-divider>发送给对方</a-divider>
          <div class="invite-block">
            <div class="invite-label">H5 注册/登录链接</div>
            <div class="invite-link">{{ inviteH5Url }}</div>
            <a-button size="small" type="primary" @click="copyInviteText(inviteH5Url)">复制链接</a-button>
          </div>
          <div class="invite-block" v-if="inviteRole === 'customer'">
            <div class="invite-label">小程序页面路径（发给您的小程序客户）</div>
            <div class="invite-link">{{ inviteMiniPath }}</div>
            <a-button size="small" type="primary" @click="copyInviteText(inviteMiniPath)">复制路径</a-button>
          </div>
          <div class="invite-tip">对方通过链接注册或登录后，双方建立伙伴绑定，并自动关联到所选档案。</div>
        </a-modal>
        <!-- 人工关联档案弹窗：兜底确保订单流转可达 -->
        <a-modal
          title="关联本方档案"
          :visible="linkVisible"
          :maskClosable="false"
          width="480px"
          @cancel="linkVisible = false"
          @ok="handleLinkOk"
          :confirmLoading="linkSubmitting">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本方档案" required>
            <a-select
              v-model="linkArchiveId"
              placeholder="请选择本方档案（仅列出未绑定的）"
              :options="linkArchiveOptions"
              allowClear />
            <div class="invite-archive-tip" v-if="!linkArchiveOptions.length">暂无可关联档案，可先在基础资料-供应商/客户管理中新增</div>
          </a-form-item>
          <div class="invite-tip">关联后，对方发来的采购订单将自动流转到您本地的对应单据往来中。</div>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getPartners, unbindPartner, getPartnerArchives, linkPartnerArchive } from '@/api/plugin/orderReceive'

export default {
  name: 'PartnerList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      urlPath: '/plugin/order-receive/partner',
      queryParam: {
        partnerName: ''
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '伙伴名称',
          dataIndex: 'partnerName',
          width: 200
        },
        {
          title: '关系',
          dataIndex: 'partnerRole',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'partnerRole' }
        },
        {
          title: '本方档案',
          dataIndex: 'myArchiveName',
          width: 160,
          scopedSlots: { customRender: 'myArchive' }
        },
        {
          title: '伙伴租户ID',
          dataIndex: 'partnerTenantId',
          width: 110,
          align: 'center'
        },
        {
          title: '绑定时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/partners'
      },
      inviteVisible: false,
      inviteRole: 'supplier',
      inviteArchiveId: undefined,
      inviteArchiveOptions: [],
      inviteH5Url: '',
      inviteMiniPath: '',
      linkVisible: false,
      linkSubmitting: false,
      linkPartnerId: null,
      linkArchiveId: undefined,
      linkArchiveOptions: []
    }
  },
  watch: {
    inviteRole() {
      this.inviteArchiveId = undefined
      this.loadInviteArchives()
      this.buildInviteLinks()
    }
  },
  methods: {
    /** 关系判定：按本方关联档案类型（供应商档案=对方是上级供应商；客户档案=对方是下级客户） */
    partnerRoleOf(record) {
      return record.archiveType === '供应商' || record.archiveType === '客户' ? record.archiveType : ''
    },
    /** 取登录态租户ID（参照 OrderCenterPrint 惯例） */
    getInviteTenantId() {
      const userInfo = this.$store && (this.$store.getters.userInfo || (this.$store.state.user && this.$store.state.user.info))
      return userInfo ? userInfo.tenantId : null
    },
    /** 档案类型：邀请供应商→本方供应商档案；邀请客户→本方客户档案 */
    archiveType() {
      return this.inviteRole === 'supplier' ? '供应商' : '客户'
    },
    /** 加载本方未绑定档案（防重复分享/绑定） */
    loadInviteArchives() {
      getPartnerArchives(this.archiveType()).then((res) => {
        if (res.code === 200) {
          this.inviteArchiveOptions = (res.data || []).map((a) => ({ label: a.supplierName, value: a.id }))
        }
      })
    },
    /** 按角色+档案拼接 H5 链接与小程序路径（链接携带 archiveId） */
    buildInviteLinks() {
      const tenantId = this.getInviteTenantId()
      if (tenantId === null || tenantId === undefined) {
        this.$message.warning('未获取到登录信息，请重新登录')
        return
      }
      const origin = window.location.origin
      const archiveParam = this.inviteArchiveId ? '&archiveId=' + this.inviteArchiveId : ''
      this.inviteH5Url = origin + '/h5/#/login?inviteTenantId=' + tenantId + '&role=' + this.inviteRole + archiveParam
      this.inviteMiniPath = '/pages_order/customer/orders?inviteTenantId=' + tenantId + '&role=' + this.inviteRole + archiveParam
    },
    openInviteModal() {
      this.inviteRole = 'supplier'
      this.inviteArchiveId = undefined
      this.loadInviteArchives()
      this.buildInviteLinks()
      this.inviteVisible = true
    },
    copyInviteText(text) {
      if (!text) {
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制')
      } catch (e) {
        this.$message.warning('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    },
    /** 人工关联档案：打开弹窗并加载未绑定档案 */
    openLinkModal(record) {
      this.linkPartnerId = record.id
      this.linkArchiveId = undefined
      // 对方是我的客户→选本方客户档案；对方是我的供应商→选本方供应商档案
      const type = this.partnerRoleOf(record) === '客户' ? '客户' : '供应商'
      getPartnerArchives(type).then((res) => {
        if (res.code === 200) {
          this.linkArchiveOptions = (res.data || []).map((a) => ({ label: a.supplierName, value: a.id }))
        }
      })
      this.linkVisible = true
    },
    handleLinkOk() {
      if (!this.linkArchiveId) {
        this.$message.warning('请选择本方档案')
        return
      }
      this.linkSubmitting = true
      linkPartnerArchive(this.linkPartnerId, this.linkArchiveId).then((res) => {
        if (res.code === 200) {
          this.$message.success('关联成功')
          this.linkVisible = false
          this.loadData()
        } else {
          this.$message.warning(res.message || '关联失败')
        }
      }).finally(() => {
        this.linkSubmitting = false
      })
    },
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        partnerName: this.queryParam.partnerName
      }
    },
    handleUnbind(record) {
      unbindPartner(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success('解绑成功')
          this.loadData()
        } else {
          this.$message.warning(res.message || '解绑失败')
        }
      })
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.invite-block { margin-bottom: 16px; }
.invite-label { color: #888; margin-bottom: 4px; }
.invite-link { background: #f5f5f5; padding: 6px 10px; border-radius: 4px; word-break: break-all; margin-bottom: 8px; color: #1890ff; }
.invite-tip { color: #999; font-size: 12px; margin-top: 8px; }
.invite-archive-tip { color: #999; font-size: 12px; margin-top: 4px; }
</style>
